import type { AppUser } from "../../services/userService";
import { auswahlTaste, type AuswahlTasteEreignis } from "./auswahlTasten";
import type { BezugKandidat } from "./bezugKandidaten";
import { bezugTreffer } from "./BezugPicker";
import { mentionTreffer } from "./MentionPicker";

/**
 * Die Tastatur der offenen `@`-/`#`-Auswahl für ein Schreibfeld (T-50).
 * Berechnet dieselben Treffer wie der sichtbare Picker und führt aus, was
 * `auswahlTaste` entscheidet. Rückgabe `true` = die Taste ist verbraucht
 * (`preventDefault` ist dann schon gerufen), das Feld tut nichts weiter.
 */
export function behandleAuswahlTastatur(
    e: AuswahlTasteEreignis & { preventDefault: () => void },
    offen: { ausloeser: "@" | "#"; query: string } | null,
    quellen: { users: AppUser[]; kandidaten?: BezugKandidat[] | undefined },
    aktiv: number,
    aktionen: {
        setAktiv: (i: number) => void;
        erwaehnen: (u: AppUser) => void;
        waehlen: (k: BezugKandidat) => void;
    },
): boolean {
    if (!offen) return false;
    if (offen.ausloeser === "@") {
        const treffer = mentionTreffer(quellen.users, offen.query);
        const r = auswahlTaste(e, treffer.length, aktiv);
        if (!r) return false;
        e.preventDefault();
        if (r.art === "weiter") aktionen.setAktiv(r.aktiv);
        else aktionen.erwaehnen(treffer[r.index]!);
        return true;
    }
    const treffer = bezugTreffer(quellen.kandidaten ?? [], offen.query);
    const r = auswahlTaste(e, treffer.length, aktiv);
    if (!r) return false;
    e.preventDefault();
    if (r.art === "weiter") aktionen.setAktiv(r.aktiv);
    else aktionen.waehlen(treffer[r.index]!);
    return true;
}
